import { render, staticRenderFns } from "./trainingNoticeList.vue?vue&type=template&id=4016db79&scoped=true&"
import script from "./trainingNoticeList.vue?vue&type=script&lang=js&"
export * from "./trainingNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./trainingNoticeList.vue?vue&type=style&index=0&id=4016db79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016db79",
  null
  
)

export default component.exports